import React, { useState, useEffect } from "react";
import { Button, Row, Col, Tabs, Spin, notification } from "antd";

import { PlusOutlined, BarsOutlined } from "@ant-design/icons";
import BankInfo from "./BankInfo";
import BkmBankInfo from "./BkmBankInfo";
import PosInfo from "./PosInfo";
import TosInfo from "./TosInfo";
import DbsInfo from "./DbsInfo";
import PosCollectionInfo from "./PosCollectionInfo";
import RequestHandler from "util/RequestHandler";
import { useHistory } from "react-router-dom";

const { TabPane } = Tabs;

const Index = () => {
  const [openBankInfoDrawer, setOpenBankInfoDrawer] = useState(0);
  const [openBkmInfoDrawer, setOpenBkmInfoDrawer] = useState(0);
  const [openPOSInfoDrawer, setOpenPOSInfoDrawer] = useState(0);
  const [openTOSInfoDrawer, setOpenTOSInfoDrawer] = useState(0);
  const [openDbsInfoDrawer, setOpenDbsInfoDrawer] = useState(0);
  const [openPosCollectionInfoDrawer, setOpenPosCollectionInfoDrawer] =
    useState(0);
  const [demoInformation, setDemoInformation] = useState(false);
  const [permissions, setPermissions] = useState({
    loading: true,
    modules: [],
  });
  const [activeTabKey, setActiveTabKey] = useState("1");
  const [bkmConsentResult, setBkmConsentResult] = useState();
  const [addButton, setAddButton] = useState({ visible: false });

  const history = useHistory();

  useEffect(() => {
    RequestHandler.get("/User/MenuPermissions").then((response) => {
      setPermissions({
        ...response,
        loading: false,
      });
      RequestHandler.get(
        `/Tenant/GetById/${localStorage.getItem("tenantId")}`
      ).then((res) => {
        if (res.isDemo) {
          setDemoInformation(true);
        }
      });
      const screenExistModuleIds = [1, 2, 3, 5, 8];
      const availableModuleIds = response.modules.filter((moduleId) =>
        screenExistModuleIds.includes(moduleId)
      );

      const result = checkIsBkmComplete();

      setActiveTabKey(result.isBkmComplete && availableModuleIds.includes(1) ? "11" : availableModuleIds[0]?.toString());
      if (result.isBkmComplete) {
        setBkmConsentResult(result);
      }
    });
  }, []);

  useEffect(() => setActiveAddButton(), [activeTabKey]);

  const checkIsBkmComplete = () => {
    const params = new URLSearchParams(window ? window.location.search : {});
    const isBkmComplete = params.get("isObComplete")?.toLowerCase() === "true";

    if (isBkmComplete) {
      const notificationType = params.get("success")?.toLowerCase() === "true" ? "success" : "error";
      notification[notificationType]({
        message: params.get("message"),
        duration: 5,
      });
      history.replace(window.location.pathname);

      return {
        isBkmComplete: isBkmComplete,
        bankInfoId: params.get("bankInfoId"),
        success: params.get("success")?.toLowerCase() === "true",
        message: params.get("message")
      };
    }

    return { isBkmComplete: isBkmComplete };
  };

  const bankInfoOnClick = (e) => {
    setOpenBankInfoDrawer((prevState) => prevState + 1);
  };
  const bkmInfoOnClick = (e) => {
    setOpenBkmInfoDrawer((prevState) => prevState + 1);
  };
  const posInfoOnClick = (e) => {
    setOpenPOSInfoDrawer((prevState) => prevState + 1);
  };
  const tosInfoOnClick = (e) => {
    setOpenTOSInfoDrawer((prevState) => prevState + 1);
  };
  const dbsInfoOnClick = (e) => {
    setOpenDbsInfoDrawer((prevState) => prevState + 1);
  };
  const posCollectionInfoOnClick = (e) => {
    setOpenPosCollectionInfoDrawer((prevState) => prevState + 1);
  };

  const setActiveAddButton = () => {
    const buttons = {
      1: {
        text: "Banka Hesap Ekle",
        onClick: bankInfoOnClick,
        onRender: () => {
          setOpenBkmInfoDrawer(0);
          setOpenTOSInfoDrawer(0);
          setOpenDbsInfoDrawer(0);
          setOpenPOSInfoDrawer(0);
          setOpenPosCollectionInfoDrawer(0);
        },
      },
      11: {
        text: "Rıza Ekle",
        onClick: bkmInfoOnClick,
        onRender: () => {
          setOpenBankInfoDrawer(0);
          setOpenTOSInfoDrawer(0);
          setOpenDbsInfoDrawer(0);
          setOpenPOSInfoDrawer(0);
          setOpenPosCollectionInfoDrawer(0);
        },
      },
      2: {
        text: "TÖS Banka Ekle",
        onClick: tosInfoOnClick,
        onRender: () => {
          setOpenBankInfoDrawer(0);
          setOpenBkmInfoDrawer(0);
          setOpenDbsInfoDrawer(0);
          setOpenPOSInfoDrawer(0);
          setOpenPosCollectionInfoDrawer(0);
        },
      },
      3: {
        text: "Dbs Banka Ekle",
        onClick: dbsInfoOnClick,
        onRender: () => {
          setOpenBankInfoDrawer(0);
          setOpenBkmInfoDrawer(0);
          setOpenTOSInfoDrawer(0);
          setOpenPOSInfoDrawer(0);
          setOpenPosCollectionInfoDrawer(0);
        },
      },
      5: {
        text: "POS Rapor Ekle",
        onClick: posInfoOnClick,
        onRender: () => {
          setOpenBankInfoDrawer(0);
          setOpenBkmInfoDrawer(0);
          setOpenTOSInfoDrawer(0);
          setOpenDbsInfoDrawer(0);
          setOpenPosCollectionInfoDrawer(0);
        },
      },
      8: {
        text: "POS Tahsilat Banka Ekle",
        onClick: posCollectionInfoOnClick,
        onRender: () => {
          setOpenBankInfoDrawer(0);
          setOpenBkmInfoDrawer(0);
          setOpenTOSInfoDrawer(0);
          setOpenDbsInfoDrawer(0);
          setOpenPOSInfoDrawer(0);
        },
      },
    };

    if (buttons[activeTabKey]) {
      setAddButton({
        text: buttons[activeTabKey].text,
        onClick: buttons[activeTabKey].onClick,
        visible: true,
      });
      buttons[activeTabKey].onRender();
    } else {
      setAddButton({
        visible: false,
      });
    }
  };

  const tabOptions = [
    {
      key: 1,
      moduleId: 1,
      title: "Banka Hesap Tanımla",
      children: <BankInfo addButtonEvent={openBankInfoDrawer} />,
    },
    {
      key: 11,
      moduleId: 1,
      title: "Açık Bankacılık Hesapları",
      children: <BkmBankInfo addButtonEvent={openBkmInfoDrawer} bkmConsentResult={bkmConsentResult} />,
    },
    {
      key: 5,
      moduleId: 5,
      title: "POS Rapor Tanımla",
      children: <PosInfo addButtonEvent={openPOSInfoDrawer} />,
    },
    {
      key: 3,
      moduleId: 3,
      title: "DBS Banka Tanımla",
      children: <DbsInfo addButtonEvent={openDbsInfoDrawer} />,
    },
    {
      key: 2,
      moduleId: 2,
      title: "TÖS Banka Tanımla",
      children: <TosInfo addButtonEvent={openTOSInfoDrawer} />,
    },
    {
      key: 8,
      moduleId: 8,
      title: "POS Tahsilat Banka Tanımla",
      children: (
        <PosCollectionInfo addButtonEvent={openPosCollectionInfoDrawer} />
      ),
    },
  ];

  return permissions.loading ? (
    <Row justify="center" align="middle" style={{ height: "100%" }}>
      <Spin />
    </Row>
  ) : (
    <>

      <Row justify="space-between" align="middle">
        <Col xs={24} sm={16}>
          <p style={{ fontSize: "120%", marginTop: -5, marginBottom: 8 }}>
            <BarsOutlined /> BANKA ERİŞİMİ TANIMLA
          </p>
        </Col>
        <Col xs={24} sm={8} style={{ textAlign: "right" }}>
          {addButton.visible && (
            <Button
              type="primary"
              onClick={addButton.onClick}
              disabled={demoInformation}
            >
              <PlusOutlined /> {addButton.text}
            </Button>
          )}
        </Col>
      </Row>

      <Tabs
        activeKey={activeTabKey}
        onChange={(key) => setActiveTabKey(key)}
      >
        {tabOptions.filter((option) => permissions.modules.includes(option.moduleId)).map((option) => {
          return (
            <TabPane
              tab={option.title}
              key={option.key}
            >
              {option.children}
            </TabPane>
          );
        })}
      </Tabs>
    </>
  );
};

export default Index;
